var mzg;
if (!mzg) {
    mzg = {};
}

$.extend(mzg,
    /**
     * @lends mzg
     */
    {
        /**
         * @namespace
         * @description Footer
         */
        footer: {
            /**
             * @type {function}
             * @description initialize Footer
             */
            init: function () {               
                var md = window.matchMedia( "(max-width: 767px)" );
                
                $('.headline--toggleList').on( "click", function() {
                    if (md.matches) {
                        $(this).toggleClass('headline--toggleListOpen').next('.list--toggle').toggleClass('list--toggled');
                    }
                });

            }
        }
    }
);

$(mzg.footer.init);


